import Loading from './loading.js'

let LoadingInstance
function getLoadingInstance (options) {
    LoadingInstance = LoadingInstance || Loading.newInstance(options)
    return LoadingInstance
}

function show(options) {
    options = options || {}
    options.onRemove = function () {
        LoadingInstance = null
    }
    let instance  = getLoadingInstance(options)
    instance.show(options)
}

function hide() {
    if (!LoadingInstance) {
        return false
    }
    let instance  = getLoadingInstance()
    instance.hide()
}

Loading.show = (options)=>{
    show(options)
}
Loading.hide = ()=>{
    hide()
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/base/loading/index.js